<template>
  <parent>
    <div class="invalidations-view-wrapper popup-wrapper">
      <div class="popup">
        <div class="popup__header">
          <h6 class="bold">
            Invalidation Details
          </h6>
          <a
            class="ml-auto"
            @click="$emit('close')"
          ><GjIcon name="Close" /></a>
        </div>
        <div
          class="popup__body"
          :class="{ 'set-height': gettingInvalidation }"
        >
          <loading-page v-if="gettingInvalidation" />
          <template v-else>
            <div class="d-flex body-row">
              <div class="w-50 text-right">
                Distribution ID
              </div>
              <div class="w-50 text-left">
                {{ invalidation.distributionId }}
              </div>
            </div>

            <div class="d-flex body-row">
              <div class="w-50 text-right">
                Invalidation ID
              </div>
              <div class="w-50 text-left">
                {{ invalidation.invalidationId }}
              </div>
            </div>

            <div class="d-flex body-row">
              <div class="w-50 text-right">
                Status
              </div>
              <div class="w-50 text-left">
                {{ status }}
              </div>
            </div>

            <div class="d-flex body-row">
              <div class="w-50 text-right">
                Created At
              </div>
              <div class="w-50 text-left">
                {{
                  formatOffsetDateTime(
                    invalidation.createdAt.endsWith('Z')
                      ? invalidation.createdAt
                      : `${invalidation.createdAt}Z`,
                  )
                }}
              </div>
            </div>

            <div class="d-flex body-row">
              <div class="w-50 text-right">
                Completed At
              </div>
              <div class="w-50 text-left">
                {{
                  invalidation.completedAt
                    ? formatOffsetDateTime(
                      invalidation.completedAt.endsWith('Z')
                        ? invalidation.completedAt
                        : `${invalidation.completedAt}Z`,
                    )
                    : '-'
                }}
              </div>
            </div>

            <div class="d-flex body-row">
              <div class="w-50 text-right">
                Object Paths
              </div>
              <div class="w-50 text-left">
                {{ invalidation.objectPaths }}
              </div>
            </div>
          </template>
        </div>
        <div class="popup__footer">
          <b-button
            variant="bg-primary"
            @click="$emit('close')"
          >
            Close
          </b-button>
        </div>
      </div>
    </div>
  </parent>
</template>
<script>
import redirectError from '@/services/redirectError'

export default {
  name: 'InvalidationView',
  props: {
    invalidationId: {
      type: String,
      required: true,
    },
  },
  computed: {
    invalidation() {
      return this.$store.state.cdn.invalidation
    },
    gettingInvalidation() {
      return this.$store.state.cdn.gettingInvalidation
    },
    distributionId() {
      return this.$route.params.id
    },
    status() {
      const loc = this.invalidation.statusOptions.find(
        x => x.id === this.invalidation.statusId,
      )
      return loc.value
    },
  },
  created() {
    this.$store
      .dispatch('cdn/getInvalidation', {
        distributionId: this.distributionId,
        id: this.invalidationId,
      })
      .catch(err => redirectError(err, this.$router, this.$route.path))
  },
}
</script>
<style lang="scss" scoped>
.set-height {
  height: 180px;
  ::v-deep {
    div {
      padding: 0 !important;
      margin: 0 !important;
      height: 100%;
    }
  }
}
</style>
